<template>
	<div id="app">
		<div v-if="offline" id="offline">OFFLINE</div>
		<router-view/>
		<floating-boxes/>
		<install-app/>
		<introduction/>
		<app-modal/>
		<app-modal-async/>
		<app-toast/>
		<change-account />
	</div>
</template>

<script>

import InstallApp from '@/components/install/InstallApp'
import Introduction from '@/components/intro/Introduction'
import ChangeAccount from '@/components/navigation/account/ChangeAccount'

export default {
	name: 'App',
	components: {
		InstallApp,
		Introduction,
		ChangeAccount
	},
	computed: {
		offline () {
			return !this.$root.online;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue